import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';
import _ from 'lodash';

export class AesListItem extends SearchModelBase {
  id: number = 0;
  shipRefNo: string = "";
  filingAction:string = "";
  
  mot:number = 0;
  transMode:string = "";

  destCountry:string = "";
  countryName:string = "";
  originState:string = "";
  unladingPort:string = "";
  exportationPort:string = "";

  espExportDate:string|null = null;
  fromEspExportDate:string|null = null;
  toEspExportDate:string|null = null;

  filingOption: number = 0;
  aeiFilingType:string = "";
  // filingOption + aesFilingType
  filingDesc:string = "";

  relatedCompany:boolean = false;
  hazmat:boolean = false;
  inboundCode:string = "";
  entryNo:string = "";
  ftzId:string = "";
  retIndicator:boolean = false;
  status:string = "";
  
  sentDate:string|null = null;
  fromSentDate:string|null = null;
  toSentDate:string|null = null;

  carrier:string = "";
  carrierName:string = "";
  cutOff:string|null = null;
  fromCutOffDate:string|null = null;
  toCutOffDate:string|null = null;

  repsonseCode:string = "";
  dpIndicator:string = "";
  severity:string = "";
  severityDesc:string = "";
  narrativeText:string = "";
  mblNo:string = "";
  sentIndicator:boolean = false;
  itn:string = "";
  reasonCode:string = "";

  createdAt:string|null = null;
  fromCreatedAt:string|null = null;
  toCreatedAt:string|null = null;

  updatedBy:string = "";
  
  updatedAt:string|null = null;
  fromUpdatedAt:string|null = null;
  toUpdatedAt:string|null = null;

  createdBy:string = "";
  usppiId:string = "";
  unladingPortName:string = "";
  exportationPortName:string = "";
  originStateName:string = "";
  usppiName:string = "";
  usppiIdType:string = "";
  rvData:string = "";
  pimsId:string = "";
  hasAccepted:boolean = false;
  vanningId:number = 0;
  hblNo:string = "";
  trn:string = "";
  cneeName:string = "";
  actionDesc:string = "";


  private static ExportCollection: XCol.XExportColumn[] = [
    //XCol.Create({ col: 0, text: '', width: 15, dataIndex: 'reserved', hiddenInColumnSetup: true }),
    XCol.Create({col: 1, text: 'Shipment Ref#', width: 130, align: XCol.XAlignType.Center, dataIndex: 'shipRefNo', defaultColumnFocus: true }),
    XCol.Create({col: 2, text: 'Status', width: 50, dataIndex: 'status', align: XCol.XAlignType.Center, hiddenInColumnSetup: true }),
    XCol.Create({col: 3, text: 'Filing Opt', width: 60, dataIndex: 'filingOption', align: XCol.XAlignType.Center}),
    XCol.Create({col: 4, text: 'Severity', width: 70, dataIndex: 'severity', align: XCol.XAlignType.Center}),
    XCol.Create({col: 5, text: 'Last Action', width: 60, dataIndex: 'filingAction', align: XCol.XAlignType.Center, hiddenInColumnSetup: true }),
    XCol.Create({col: 6, text: 'ITN', width: 100, dataIndex: 'itn', align: XCol.XAlignType.Center}),
    XCol.Create({col: 7, text: 'Exporter (USPPI)', width: 180, dataIndex: 'usppiName', align: XCol.XAlignType.Center}),
    XCol.Create({col: 8, text: 'USPPI ID', width: 80, dataIndex: 'usppiId', align: XCol.XAlignType.Center}),
    XCol.Create({col: 9, text: 'U. Consignee', width: 180, dataIndex: 'cneeName', align: XCol.XAlignType.Center}),
    //XCol.Create({col: 10, text: 'Equipment #', width: 95, dataIndex: 'equipment', align: XCol.XAlignType.Center}),
    XCol.Create({col: 11, text: 'Export Date', width: 85, dataIndex: 'espExportDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
    XCol.Create({col: 12, text: 'MOT', width: 35, dataIndex: 'mot', align: XCol.XAlignType.Center}),
    //XCol.Create({col: 13, text: 'Transport', width: 80, dataIndex: 'transMode', align: XCol.XAlignType.Center}),

    XCol.Create({col: 14, text: 'Dest', width: 35, dataIndex: 'destCountry', align: XCol.XAlignType.Center}),
    //XCol.Create({col: 15, text: 'Dest Country', width: 150, dataIndex: 'countryName', align: XCol.XAlignType.Center}),
    XCol.Create({col: 16, text: 'Org State', width: 35, dataIndex: 'originState', align: XCol.XAlignType.Center}),
    XCol.Create({col: 17, text: 'Carrier', width: 50, dataIndex: 'carrier', align: XCol.XAlignType.Center}),
    XCol.Create({col: 18, text: 'Carrier Name', width: 158, dataIndex: 'carrierName', align: XCol.XAlignType.Center}),
    XCol.Create({col: 19, text: 'Export Port', width: 48, dataIndex: 'exportationPort', align: XCol.XAlignType.Center}),
    //XCol.Create({col: 20, text: 'Export Port Name', width: 170, dataIndex: 'exportationPortName', align: XCol.XAlignType.Center}),
    XCol.Create({col: 19, text: 'Unlading Port', width: 48, dataIndex: 'unladingPort', align: XCol.XAlignType.Center}),
    //XCol.Create({col: 19, text: 'Unlading Port Name', width: 48, dataIndex: 'unladingPortName', align: XCol.XAlignType.Center}),
    XCol.Create({col: 21, text: 'Sent Date', width: 120, dataIndex: 'sentDate', type: XCol.XCellType.DateTimeWithSec, align: XCol.XAlignType.Center}),
    // XCol.Create({col: 22, text: 'Create By', width: 120, dataIndex: 'createdBy'}),
    // XCol.Create({col: 23, text: 'Create Date', width: 100, dataIndex: 'createdAt', type: XCol.XCellType.DateTime, align: XCol.XAlignType.Center}),
    XCol.Create({col: 24, text: 'Update By', width: 120, dataIndex: 'updatedBy'}),
    XCol.Create({col: 25, text: 'Update Date', width: 120, dataIndex: 'updatedAt', type: XCol.XCellType.DateTimeWithSec, align: XCol.XAlignType.Center}),
  ];

    public static getExportCollection( ): XCol.XExportColumn[] {
        let returnCloumns = _.cloneDeep(this.ExportCollection);
        return returnCloumns;
    }
	
    public static OrderBy = { orderBy: AesListItem.prototype.id, orderByAscending: false };

    public static formatData(data: AesListItem[]) {
        return data.map((d: AesListItem) => ({
          ...d,
        }));
    }


    public static MapSearchFields: {[key: string]: {[key: string]: string}} = {
        espExportDate: {from: 'fromEspExportDate', to: 'toEspExportDate'},
        createdAt: {from: 'fromCreatedAt', to: 'toCreatedAt'},
        updatedAt: {from: 'fromUpdatedAt', to: 'toUpdatedAt'},
        cutOffDate: {from: 'fromCutOffDate', to: 'toCutOffDate'},
        sentDate: {from: 'fromSentDate', to: 'toSentDate'}
    };

}